import JoinOrganisationForm from "@/features/organisations/components/JoinOrganisationForm";
import { ProfileAttributePage, useProfileAttributePage } from "@/features/profile/components/ProfileAttributePage";
import { hooks as h } from "@/hooks";
import { createFileRoute } from "@tanstack/react-router";

function NewOrganisation() {
    const { copy, goToProfile } = useProfileAttributePage();

    h.useNav([
        { label: copy.title, route: { to: "/profile" } },
        { label: copy.organisation, route: { to: "/profile/organisation" } },
    ]);

    return (
        <ProfileAttributePage title={copy.organisation} description={copy.profileOrganisationDescription}>
            <JoinOrganisationForm isOnboarding={false} onBack={goToProfile} />
        </ProfileAttributePage>
    );
}

export const Route = createFileRoute("/_app/profile/organisation")({
    component: NewOrganisation,
});
